import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeaderOrg from '../../../Headers/HeaderOrg';
import Help from '../../../../Components/Help/Help';
import Loader from '../../../../Components/Loader/Loader';
import { serviceConsumer } from '../../../../network/ServiceConsumer';
import ManageTitle from '../../../../Components/TitleElements/ManageTitle';
import { getPrintHandler } from '../../../../helper/printHandlers';
import Checkbox from "../../../../Components/Checkbox/Checkbox"
import TextError from '../../../../Components/formik/TextError';
import { sortCompetitions } from '../../../../helper/SortSyllabus';

const CheckIn = () => {
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const eventId = searchParams.get('id')

    const [event, setEvent] = useState()
    const [levels, setLevels] = useState([])
    const [competitions, setCompetitions] = useState([])
    const [competitors, setCompetitors] = useState([])
    const [competitionCode, setCompetitionCode] = useState("")
    const [competitionGroup, setCompetitionGroup] = useState("")
    const [competitionId, setCompetitionId] = useState("")
    const [loading, setLoading] = useState(false)
    const [initialLoading, setInitialLoading] = useState(false)
    const [stages, setStages] = useState([]);
    const [filterType, setFilterType] = useState("Level")
    const [selectedStage, setSelectedStage] = useState("");
    const [err, setErr] = useState("")

    const getInitialDetails = async () => {
        try {
            setInitialLoading(true)

            const eventUrl = `${process.env.REACT_APP_BASE_URL}/feis/${eventId}`
            const eventResponse = await serviceConsumer('GET', eventUrl)
            setEvent(eventResponse.Feis)

            const levelUrl = `${process.env.REACT_APP_BASE_URL}/feis/levels/checkIn`
            const levelResponse = await serviceConsumer("POST", levelUrl, { id: eventId })
            setLevels(levelResponse.result)

            const stagesUrl = `${process.env.REACT_APP_BASE_URL}/schedule-maker/list-check-in-stages/${eventId}`
            const stagesResponse = await serviceConsumer("GET", stagesUrl)
            setStages(stagesResponse?.result || []);

            const competitionsUrl = `${process.env.REACT_APP_BASE_URL}/feis/level/competitions`
            const competitionsResponse = await serviceConsumer("POST", competitionsUrl, {
                feis_id: eventId,
                level: levelResponse.result[0]
            })

            const competitionsWithDancers = competitionsResponse.result.filter(c => c.dancers.length > 0)
            const sorted = sortCompetitions(competitionsWithDancers)

            setCompetitions(sorted)
            setCodeIdGroup(sorted[0])

            const competitorsUrl = `${process.env.REACT_APP_BASE_URL}/feis/competition/dancers/${sorted[0]._id}`;
            const competitorsResponse = await serviceConsumer("GET", competitorsUrl)
            setCompetitors(competitorsResponse.result)

            setInitialLoading(false)
        } catch {
            setInitialLoading(false)
        }
    };

    useEffect(() => {
        getInitialDetails();
    }, []);

    useEffect(() => {
        setErr("")
    }, [competitionId, levels])

    const setCodeIdGroup = (competition) => {
        setCompetitionCode(competition.code)
        setCompetitionId(competition._id)
        setCompetitionGroup(competition.group)
    }

    const getCompetitors = async (id) => {
        try {
            setLoading(true)
            const url = `${process.env.REACT_APP_BASE_URL}/feis/competition/dancers/${id}`;
            const response = await serviceConsumer("GET", url)
            setCompetitors(response.result)
            setLoading(false)
        } catch {
            setLoading(false)
        }
    }

    const getCompetitions = async (level) => {
        try {
            setLoading(true)
            const response = await serviceConsumer("POST",
                `${process.env.REACT_APP_BASE_URL}/feis/level/competitions`,
                { feis_id: eventId, level }
            )

            const filtered = response.result.filter(c => c.dancers.length > 0)
            const sorted = sortCompetitions(filtered)

            setCompetitions(sorted)
            setCodeIdGroup(sorted[0])
            getCompetitors(sorted[0]._id)
            setLoading(false)
        } catch {
            setLoading(false)
        }
    }

    const handleLevelChange = (e) => {
        getCompetitions(e.target.value)
    }

    const handleFilterTypeChange = e => {
        const value = e.target.value;
        setFilterType(value);
        setErr("");

        if (value === "Stage") {
            setCompetitionGroup("");
            setSelectedStage("");

            if (stages.length > 0) {
                const stage = stages[0];
                setSelectedStage(stage.stage);

                // a competition merged away since it was scheduled, or an
                // empty stage, has nothing to check in (card a1f0fff5)
                const comps = (stage.competitions || []).map(c => c?.competitionDetails).filter(c => c?._id);
                setCompetitions(comps);

                if (comps.length > 0) {
                    setCodeIdGroup(comps[0]);
                    getCompetitors(comps[0]._id);
                } else {
                    setCompetitionId("");
                    setCompetitors([]);
                }
            }
        } else {
            setSelectedStage("");

            if (levels.length > 0) {
                setCompetitionGroup(levels[0]);
                getCompetitions(levels[0]);
            }
        }
    };

    const handleStageChange = e => {
        const value = e.target.value;
        const comps = (stages.find(s => s.stage == value)?.competitions || []).map(c => c?.competitionDetails).filter(c => c?._id).map(c => ({ ...c }));
        setCompetitions(comps);
        setSelectedStage(value);
        if (comps.length > 0) {
            setCodeIdGroup(comps[0]);
            getCompetitors(comps[0]._id);
        } else {
            setCompetitionId("");
            setCompetitors([]);
        }
    }

    const handleCompetitionChange = e => {
        const selected = competitions.find(c => c._id === e.target.value)
        setCodeIdGroup(selected)
        getCompetitors(selected._id)
    }

    /* 🔽 NEW: Arrow navigation handlers */
    const handlePrevCompetition = () => {
        const index = competitions.findIndex(c => c._id === competitionId)
        if (index > 0) {
            const prev = competitions[index - 1]
            setCodeIdGroup(prev)
            getCompetitors(prev._id)
        }
    }

    const handleNextCompetition = () => {
        const index = competitions.findIndex(c => c._id === competitionId)
        if (index < competitions.length - 1) {
            const next = competitions[index + 1]
            setCodeIdGroup(next)
            getCompetitors(next._id)
        }
    }

    const textBtnHandler = () => {
        getPrintHandler(
            `${process.env.REACT_APP_BASE_URL}/feis/checkInSheet/pdf/${competitionId}`,
            setLoading
        );
    }

    const isChecked = dancer =>
        dancer.checked.some(i => i.competitionId === competitionId && i.check)

    const checkBoxHandler = async (dancer) => {
        try {
            await serviceConsumer("POST",
                `${process.env.REACT_APP_BASE_URL}/feis/checkStatus/change`,
                { reg_id: dancer._id, check: !isChecked(dancer), compId: competitionId }
            )
            setErr("")
            getCompetitors(competitionId)
        } catch (err) {
            setErr(err.messages)
        }
    }

    return (
        <>
            {(loading || initialLoading) && <Loader />}
            <HeaderOrg />

            <ManageTitle
                eventLogo={event?.logo}
                eventName={event?.name}
                eventType={event?.eventType}
                eventDate={event?.feis_date}
                textButton={"Print check-in sheets"}
                className={competitions.length ? 'text-btn' : 'text-btn-disabled'}
                textBtnHandler={textBtnHandler}
                loading={initialLoading}
            />

            {!initialLoading &&
                <div className="org-body-white">
                    <div className="org-body-title pt-4">Check-in Sheet</div>
                    <div className="mt-1 hr-org-body"></div>

                    <div className="d-md-flex mt-4 gap-md-4">
                        <div className="d-flex align-items-end gap-3">
                        <div className="d-flex gap-1 mb-1">
                                <button className="arrow-btn" onClick={handlePrevCompetition}>◀</button>
                                <button className="arrow-btn" onClick={handleNextCompetition}>▶</button>
                            </div>
                            <div>
                                <div className="search-label">Select type:</div>
                                <select
                                    className="check-in-select"
                                    onChange={handleFilterTypeChange}
                                    value={filterType}
                                >
                                    {["Stage", "Level"].map(t =>
                                        <option key={t} value={t}>{t}</option>
                                    )}
                                </select>
                            </div>
                        </div>

                        {filterType === "Level" ?
                            <div>
                                <div className="search-label">Select a level:</div>
                                <select className="check-in-select" onChange={handleLevelChange} value={competitionGroup}>
                                    {levels.map(l => <option key={l} value={l}>{l}</option>)}
                                </select>
                            </div>
                            :
                            <div>
                                <div className="search-label">Select a Stage:</div>
                                <select className="check-in-select" onChange={handleStageChange} value={selectedStage}>
                                    {stages.map(s => <option key={s.stage} value={s.stage}>{s.stageName}</option>)}
                                </select>
                            </div>
                        }

                        <div>
                            <div className="search-label">Select a competition:</div>
                            <select className="check-in-select" onChange={handleCompetitionChange} value={competitionId}>
                                {competitions?.map(c =>
                                    <option key={c._id} value={c._id}>{c.code}-{c.group}</option>
                                )}
                            </select>
                        </div>
                    </div>
                    <div style={{ width: "100%", overflowX: "scroll", marginTop: "30px", marginBottom: "50px" }}>
                    <table className="table my_table competitorTable ">
                        <tbody>
                            <tr className="header-row">
                                <td className="text-center mx-5 w-6 p-25-5"></td>
                                <td className="text-center mx-5 w-6 p-25-5">#</td>
                                <td className="mx-5 w-25 p-25-5">Competitor</td>
                                <td className="w-33 p-25-5">School Name</td>
                                <td className="text-center w-20 p-25-5">DOB</td>
                                <td className='text-center w-10 p-25-5'>Competition</td>
                            </tr>
                            {competitors?.map((dancer,) => {
                                return <tr key={dancer?.card_number} style={{ background: "#FFFFFF", fontSize: "12px", height: "31px" }}>
                                    <td className="text-center mx-5 w-6 grey-42 p-25-5"><Checkbox onChange={() => checkBoxHandler(dancer)} checked={isChecked(dancer)} /></td>
                                    <td className="text-center mx-5 py-4 w-6 grey-30">{dancer?.card_number}</td>
                                    <td className="mx-5 w-25 grey-30">{dancer?.dancerData?.fname}&nbsp;{dancer?.dancerData?.lname}</td>
                                    <td className="w-33 grey-30">{dancer?.dancerData?.school}</td>
                                    <td className="text-center w-20 grey-30">{dancer?.dancerData?.birthday}</td>
                                    <td className='text-center w-10 grey-30'>{competitionCode}</td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                    {!loading && competitors.length === 0 && <div className="d-flex justify-content-center my-5">There are no competitors registered for this event</div>}
                    {err && <TextError>{err}</TextError>}
                </div>
                </div>
            }
            <Help />
        </>
    )
}

export default CheckIn
